4<template>
    <div class="device-type-manange relative">
        <!-- 表单开始 -->
        <div class="buttons" :style="{position: button_position}">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button @click="addAd">新增</el-button>
            <el-button @click="goSort">保存排序</el-button>
        </div>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="8" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">角色类型：</span>
                <el-select
                    clearable
                    class="status" v-model="adForm.user_role" placeholder="请选择角色类型" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in user_role"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="8" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">广告标题：</span>
                <el-input v-model="adForm.title" style="width: calc(100% - 6em) !important;" placeholder="请输入广告标题关键词"/>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="8" :lg="4" :xl="4":sm="12" :xs="24">
                <span class="fs-14 pd-r-10">广告类型：</span>
                <el-select
                    clearable
                    class="status" v-model="adForm.type" placeholder="请选择广告类型" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in type"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="8" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">可用状态：</span>
                <el-select
                    clearable
                    class="status" v-model="adForm.status" placeholder="请选择广告状态" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="8" :lg="4" :xl="4" :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column width="60" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="title" label="标题" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="role_name" label="所属角色" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="type_txt" label="类型" width="160" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="content" label="内容" align="center" label-class-name="label" v-slot="scope">
                <div v-if="scope.row.type == 2">
                    <div style="display: inline;margin-right: 2px" v-for="(img, index) in scope.row.content"
                                                     @click="previewImage(scope.row.content, index, scope.row.title)">
                    <i class="el-icon-picture-outline"></i></div></div>
                <div v-if="scope.row.type == 1">
                    <div @click="handleVideoPreview(scope.row)">
                        <i class="el-icon-picture-outline"></i></div>
                </div>
                <div v-if="scope.row.type == 3 || scope.row.type == 4 || scope.row.type == 5">
                    <div class="ad-coentent" @click="contentPreview(scope.row)">查看</div>
                </div>
                <el-dialog :title="video_title" class="video-dialog" :visible.sync="dialogVisible" append-to-body>
                    <video width="100%" controls="controls" style="object-fit: contain;max-height: 760px;" :src="videoUrl"></video>
                </el-dialog>
                <el-dialog :title="content_title" :visible.sync="dialogContentVisible" append-to-body>
                    <div v-html="ad_content" style="height: 500px;overflow: hidden;overflow-y: auto;line-height: 2em"></div>
                </el-dialog>
            </el-table-column>
<!--            <el-table-column prop="thumb" width="80" label="封面" align="center" label-class-name="label" v-slot="scope">-->
<!--                <div v-if="scope.row.thumb">-->
<!--                    <div @click="previewImage([{file:scope.row.thumb}],  0, '封面预览')">-->
<!--                    <i class="el-icon-picture-outline"></i></div></div>-->
<!--            </el-table-column>-->
            <el-table-column prop="status_txt" width="80" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="240" label="排序序号" align="center" label-class-name="label">
                <template scope="scope">
                    <el-input v-model="scope.row.sort" min="0"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="update_date" label="更新日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button  @click="goEdit(scope.row)" type="text" size="mini">编辑</el-button>
                <el-button  @click="startStopAd(scope.row, 1)" type="text" size="mini"  v-if="scope.row.status==2">启用</el-button>
                <el-button  @click="startStopAd(scope.row, 2)" type="text" size="mini"  v-if="scope.row.status==1">停用</el-button>
                <el-button  @click="deleteAd(scope.row)" type="text" size="mini">删除</el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <el-dialog :title="preview_title" :visible.sync="dialogImgFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="outside" height="500px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="(url, n) in imageUrl" :key="n">
                    <div class="image_box">
                        <el-image :src="url"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import pdf from "vue-pdf";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                preview_title: '',
                content_title:'',
                video_title:'',
                imageUrl: [],
                imgPREFIX: env.IMG_COMMON_URL_PREFIX,
                videoUrl: '',
                dialogImgFormVisible: false,
                dialogVisible: false,
                dialogContentVisible: false, // 内容详情弹窗
                ad_content: "",
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_role: [
                    {
                        id: "1",
                        name: "特属服务对象",
                    },
                    {
                        id: "3",
                        name: "特属专家",
                    },
                    {
                        id: "9",
                        name: "所有用户",
                    },
                    {
                        id: "11",
                        name: "特属服务对象加入条件",
                    },
                    {
                        id: "31",
                        name: "特属专家加入条件",
                    },
                ],
                type: [
                    {
                        id: 1,
                        name: "视频",
                    },
                    {
                        id: 2,
                        name: "多图",
                    },
                    {
                        id: 3,
                        name: "纯文本",
                    },
                    {
                        id: 4,
                        name: "图文结合",
                    },
                    {
                        id: 5,
                        name: "文字+封面",
                    },
                ],
                allStatus: [
                    {
                        id: 1,
                        name: '启用'
                    },
                    {
                        id: 2,
                        name: '停用'
                    }
                ],
                adForm: {
                    title: '',
                    type: '',
                    user_role: '',
                    status: '',
                },
                is_submit: false,
                button_position: 'absolute',
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
        },
        mounted() {
            // 获取广告列表
            this.getList();
        },
        methods: {
            // 获取所有宣传广告
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'adList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        title: this.adForm.title,
                        role_id: this.adForm.user_role,
                        type: this.adForm.type,
                        status: this.adForm.status,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    let temp_content = [];
                    let arr = [];
                    for (let i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        // 所属角色
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status_txt = '启用';
                                break;
                            case '2':
                                res.data.data.list[i].status_txt = '停用';
                                break;
                        }
                        // 所属角色
                        switch (res.data.data.list[i].role_id) {
                            case '1':
                                res.data.data.list[i].role_name = '特属服务对象';
                                break;
                            case '3':
                                res.data.data.list[i].role_name = '特属专家';
                                break;
                            case '11':
                                res.data.data.list[i].role_name = '特属服务对象加入条件';
                                break;
                            case '31':
                                res.data.data.list[i].role_name = '特属专家加入条件';
                                break;
                            case '9':
                                res.data.data.list[i].role_name = '所有用户';
                                break;
                        }
                        // 广告类型
                        switch (res.data.data.list[i].type) {
                            case '1':
                                res.data.data.list[i].type_txt = '视频';
                                res.data.data.list[i].content = this.imgPREFIX + res.data.data.list[i].content;
                                break;
                            case '2':
                                res.data.data.list[i].type_txt = '多图';
                                temp_content = JSON.parse(res.data.data.list[i].content);

                                for (let j = 0; ; j++) {
                                    if (!temp_content[j]) break;
                                    arr.push({file:this.imgPREFIX + temp_content[j].file})
                                }
                                res.data.data.list[i].content = arr;
                                break;
                            case '3':
                                res.data.data.list[i].type_txt = '纯文本';
                                break;
                            case '4':
                                res.data.data.list[i].type_txt = '图文';
                                break;
                            case '5':
                                res.data.data.list[i].type_txt = '文本+封面';
                                break;
                        }

                        if (res.data.data.list[i].thumb) {
                            res.data.data.list[i].thumb = this.imgPREFIX + res.data.data.list[i].thumb
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },
            // 视频预览
            handleVideoPreview(data) {
                this.videoUrl = '';
                this.videoUrl = data.content;
                this.video_title = data.title;
                this.dialogVisible = true;
            },
            // 文本、图文预览
            contentPreview(data) {
                let content = data.content
                if (data.type == 4) {
                    let imgReg = /<img.*?(?:>|\/>)/gi;
                    let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
                    let allImage = content.match(imgReg);
                    if (allImage) {
                        for (let i = 0; i < allImage.length; i++) {
                            let src = allImage[i].match(srcReg);

                            //获取图片地址
                            if (src[1] && src[1].indexOf("http") == -1 && src[1].indexOf("https") == -1) {
                                content = content.replace(new RegExp(src[1], 'g'), this.imgPREFIX + src[1]);
                            }
                        }
                    }
                    content = `<pre className="panel-body" style="white-space: pre-wrap;line-height: 2em;">${content}</pre>`
                }
                if (data.type == 3 || data.type == 5) {
                    content = `<pre className="panel-body" style="white-space: pre-line;line-height: 2em;">${content}</pre>`
                }
                this.ad_content = content
                this.dialogContentVisible = true;
                this.content_title = data.title
            },
            // 预览
            async previewImage(data, index, title){
                if (this.$refs.image_box) {
                    this.$refs.image_box.setActiveItem(index)
                }
                this.imageUrl = [];

                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        this.imageUrl.push(data[i].file);
                    }
                }

                this.preview_title = title
                this.active_index = index
                this.dialogImgFormVisible = true;

            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            // 新增
            addAd() {
                this.$router.push({
                    name: "adEdit", params: {}
                });
            },
            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "adEdit", params: {
                        id: data.id,
                    }
                });
            },
            // 排序
            goSort() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                let sortData = this.getSortData(this.tableData);

                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'adReSort',
                    params: {
                        sortData: sortData
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '修改成功',
                        duration: 1500,
                    });
                    _that.getList();
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 启用停用宣传广告
            startStopAd(data, status) {
                let message = '';
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (status == '1') {
                    message = '确定启用该宣传广告吗？';
                }
                if (status == '2') {
                    message = '确定停用该宣传广告吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_ContentServices',
                        method: 'startStopAd',
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 删除设备类型
            deleteAd(val) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定该删除该宣传广告吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_ContentServices',
                        method: 'deleteAd',
                        params: {
                            id: val.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message.success('删除成功！');
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            getSortData(data) {
                let res = [];
                for (let i = 0; i < data.length; i++) {
                    res.push({
                        id: data[i].id,
                        sort: data[i].sort,
                    })
                }
                return res;
            },
            // 重置按钮
            resetForm() {
                this.adForm.title = "";
                this.adForm.user_role = "";
                this.adForm.type = "";
                this.adForm.status = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .image_box {
        height: 500px;
        overflow: hidden;
        overflow-y: auto;

        image {
            width: 100%;
        }
    }
    .el-icon-picture-outline,.ad-coentent{color: #6B99F0;cursor: pointer;}
    .video-dialog{
        .el-dialog{
            margin-top: 3vh !important;
            margin-bottom: 20px !important;
        }
    }
    .inputs .el-select.status .el-input {
        width: 100%;
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .buttons{
        .el-button{
            width: 90px !important;
        }
    }
</style>
